import React, { useState, useEffect } from 'react'
import {
  Box,
  TextArea,
  Text,
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHeader,
} from 'grommet'
import { isMobileOnly } from 'react-device-detect'
import { useDispatch, useSelector } from 'react-redux'
import { CircleInformation } from 'grommet-icons'
import InfoButton from '../Button/InfoButton'
import { setChoices, setFormulaFieldValue } from '../../redux/rng/actions'

const FormulaInput = () => {
  const [formulaValue, setFormulaValue] = useState('')
  const formulaValuePersist = useSelector(state => state.rng.formulaFieldValue)
  const dispatch = useDispatch()

  const getAllRangeValues = (start, stop, step) =>
    Array.from(
      { length: (stop - start) / step + 1 },
      (_, i) => start + i * step,
    )

  // const range2 = (from, to, step) =>
  //   [...Array(Math.floor((to - from) / step) + 1)].map(
  //     (_, i) => from + i * step,
  //   )

  useEffect(() => {
    if (formulaValue !== formulaValuePersist) {
      processValue(formulaValuePersist)
      setFormulaValue(formulaValuePersist)
    }
  }, [formulaValuePersist])

  const processValue = oriValue => {
    const rangePattern = new RegExp(/^[(\[](.*)[)\]]$/) //match range formula beginning and ending with brackets and square brackets
    const value = oriValue.replace(/\s/g, '')
    if (value === '') {
      dispatch(setChoices([]))
      dispatch(setFormulaFieldValue(oriValue))
      return
    }
    const formulaArray = value.split(',')
    const rangeArray = formulaArray.filter(
      el => el.length && rangePattern.test(el),
    )
    const numberArray = formulaArray
      .filter(el => el.length && el == +el)
      .map(Number)

    const range1Pattern = new RegExp(/^[(\[][-0-9]+[:;][-0-9]+[)\]]$/) // range formula with step 1
    const range2Pattern = new RegExp(
      /^[(\[][-0-9]+[:;][-0-9]+[:;][-0-9]+[)\]]$/,
    ) // range formula with diff step
    let allRangeNumbersArray = []
    for (let element of rangeArray) {
      const string = element.slice(1, -1)
      let start, stop, step
      if (range1Pattern.test(element)) {
        const parameters = string.split(/[:;]+/).map(Number)
        start = parameters[0]
        stop = parameters[1]
        step = 1
      } else if (range2Pattern.test(element)) {
        const parameters = string.split(/[:;]+/).map(Number)
        start = parameters[0]
        stop = parameters[2]
        step = parameters[1]
      } else {
        continue
      }
      allRangeNumbersArray = allRangeNumbersArray.concat(
        getAllRangeValues(start, stop, step),
      )
    }

    const allCompiledNumbers = [
      ...new Set([...numberArray, ...allRangeNumbersArray]),
    ].sort((a, b) => a - b)
    const maxLimit = isMobileOnly ? 500 : 1000
    if (allCompiledNumbers.length > maxLimit)
      allCompiledNumbers.splice(maxLimit)
    dispatch(setChoices(allCompiledNumbers))
    dispatch(setFormulaFieldValue(oriValue))
  }

  const infoTable = (
    <Table>
      <TableHeader>
        <TableRow>
          <TableCell scope="col" border="bottom">
            <strong>Type</strong>
          </TableCell>
          <TableCell scope="col" border="bottom">
            <strong>Formula</strong>
          </TableCell>
          <TableCell scope="col" border="bottom">
            <strong>Example</strong>
          </TableCell>
          <TableCell scope="col" border="bottom">
            <strong>Number Shown</strong>
          </TableCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        <TableRow>
          <TableCell scope="row">Single</TableCell>
          <TableCell>any number</TableCell>
          <TableCell>1,2,3,4,5</TableCell>
          <TableCell>1,2,3,4,5</TableCell>
        </TableRow>
        <TableRow>
          <TableCell scope="row">Range</TableCell>
          <TableCell>(min;max)</TableCell>
          <TableCell>(1;5)</TableCell>
          <TableCell>1,2,3,4,5</TableCell>
        </TableRow>
        <TableRow>
          <TableCell scope="row">Range with Step</TableCell>
          <TableCell>(min;interval;max)</TableCell>
          <TableCell>(0;2;10)</TableCell>
          <TableCell>0,2,4,6,8,10</TableCell>
        </TableRow>
        <TableRow>
          <TableCell colSpan={4}>
            *use comma , to combine several formulas
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell colSpan={4}>
            *use either brackets () or square brackets [] for Range type
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell colSpan={4}>
            *use either colon : or semicolon ; for Range type
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  )

  return (
    <Box flex={true}>
      <Box direction="row">
        <Text>Formula: </Text>
        <InfoButton content={infoTable} width="45rem" />
      </Box>

      <Box
        background="secondaryBg"
        margin={{ top: '.2rem' }}
        style={{ position: 'relative' }}
        // flex={true}
      >
        <TextArea
          plain
          value={formulaValue}
          placeholder="E.g. 1,2,3,(10;15),(20;2;30)"
          onChange={event => setFormulaValue(event.target.value)}
          resize="vertical"
          rows={7}
        />
        <Button
          primary
          color="secondary"
          label="Process"
          onClick={() => processValue(formulaValue)}
          style={{
            position: 'absolute',
            bottom: '1rem',
            right: '1rem',
            // padding: '8px 30px',
          }}
          // size="small"
        />
      </Box>
      <Text size="1.2rem" style={{ display: 'flex', alignItems: 'center' }}>
        * Click the tips{' '}
        <CircleInformation size="12px" style={{ margin: '0 .3rem' }} />
        to learn more about the formula
      </Text>
    </Box>
  )
}

export default FormulaInput
